module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/facebook-white-6fba3e16d3c3655362e927bf22ac20a4.svg";